import styled from 'styled-components';

const Row = styled.tr<{ headerRow?: boolean }>`
  td:first-child {
    border-left: none;
  }
  td:last-child {
    border-right: none;
    border-left: none;
  }
  ${({ headerRow }) => {
    if (headerRow) {
      return `
        cursor: pointer !important;
        label {
          cursor: pointer !important;
        }

        td:first-child{
          border-right: none;
        }
        td:last-child{
        }
      `;
    }
  }}
`;

export default Row;
